export const specialCharacterValidatorRegExp = /\W/;
export const specialCharactersValidatorRegExp = /^\W+$/;

export const validateSpecialCharacter = (
  string: string,
): boolean => specialCharacterValidatorRegExp.test(string);
export const validateSpecialCharacters = (
  string: string,
): boolean => specialCharactersValidatorRegExp.test(string);
